export * from './lib/click-outside.module';
